import { NavLink } from "react-router-dom";
import { useApi } from "@/hooks/useApi";
import { getPluginAdminNav } from "@/api/endpoints";
import { Icon } from "@/layouts/AppShell";
import { pluginEmbedPath } from "@/lib/pluginLibrary";

/**
 * Admin-section nav items contributed by AdminProvider/v1 plugins (#547).
 *
 * Enabled plugins declaring `admin` surfaces in their manifest are listed by
 * core at /api/v1/plugins/admin-nav (admin-only). Each surface is the plugin's
 * own admin page served through the knotfin origin under /plugins/{id}/…; the
 * entry routes to the in-shell embed (/apps/{id}/…) so the sidebar and theme
 * stay put. Core also gates the surface path itself, so this is a convenience
 * surface, not the security boundary. Defensive by design: a fetch failure, an
 * empty list, or a malformed entry renders nothing — a broken plugin must
 * never break the shell.
 */
export function AdminPluginNavItems({
  showLabels,
  onNavigate,
}: {
  showLabels: boolean;
  onNavigate?: () => void;
}) {
  const nav = useApi(() => getPluginAdminNav(), []);
  const entries = (nav.data?.data ?? []).filter(
    (entry) => Boolean(entry?.attributes?.ui_url) && Boolean(entry?.attributes?.name),
  );
  if (entries.length === 0) return null;
  return (
    <>
      {entries.map((entry) => (
        <NavLink
          key={entry.id}
          to={pluginEmbedPath(entry.attributes.ui_url)}
          className="nav-item"
          onClick={onNavigate}
        >
          <Icon name="puzzle" />
          {showLabels && <span>{entry.attributes.name}</span>}
        </NavLink>
      ))}
    </>
  );
}
